module.exports = __webpack_public_path__ + "static/media/MAYANK-SHARMA.b4e56aee.png";